import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@mode/capra';
import { PlanCardComponent } from '../plan-card/plan-card.component';
@Component({
  selector: 'mode-business-plan',
  standalone: true,
  imports: [CommonModule, IconComponent, PlanCardComponent],
  templateUrl: './business-plan.component.html',
  styleUrls: ['./business-plan.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessPlanComponent {
  public readonly planFeatures: readonly string[] = [
    'Unlimited users',
    '5GB/query',
    '250GB monthly throughput',
    'dbt Semantic Layer integration',
    'SCIM/SAML',
    'Unlimited datasets & collections',
    'API access',
    'Dedicated CSM',
  ];
  @Input() isUpgradePlansFlow = false;
}
